import { anyObject } from "@cervval.js/common/src/tools/any.tools";
import { objectKeys } from "@cervval.js/common/src/tools/object.tools";
import { anyReallyAny } from "@cervval.js/common/tools";

/** Generique typeguard */
export function isType<T, K extends keyof T = keyof T>(obj: anyReallyAny, key: K, value?: T[K]): obj is T {
    return (obj as T)?.[key] != null && (value === undefined || obj[key] === value);
}


/** */
export function isTypeWithProp<T extends anyObject, K extends string>(obj: T, prop: K): obj is T & Record<K, anyReallyAny> {
    return objectKeys(obj).includes(prop);
}